export default class StudentInfoController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $document, student
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$document = $document;
    this.student = student;
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
